import React from "react";
import { lazily } from "react-lazily";
import { filterRoutes } from "@/utils/featureFlipDependepent";

const Home = React.lazy(() => import("@pages/index"));

// Account
const AccountArea = React.lazy(() => import("@pages/account/index"));
const ChangePassword = React.lazy(() =>
    import("@pages/account/change-password/index")
);
const ChangePasswordConnected = React.lazy(() =>
    import("@pages/account/change-password-connected/index")
);


// Assistance & Policy
const Assistance = React.lazy(() => import("@pages/assistance/index"));
const AssistanceRegisterAccountmanagement = React.lazy(() =>
    import("@pages/assistance/registration-account-management/index")
);
const Policy = React.lazy(() => import("@pages/policy/index"));

// Surveys
const Surveys = React.lazy(() => import("@pages/surveys/index"));
const Survey = React.lazy(() => import("@pages/survey/surveyId/index"));
const SurveyLanguage = React.lazy(() =>
    import("@pages/survey/surveyId/language/index")
);
const SurveyQuestions = React.lazy(() =>
    import("@pages/survey/surveyId/questions/index")
);
const SurveyCompletionPage = React.lazy(() =>
    import("@pages/survey/surveyId/completedPage")
);

// Focus Groups
const Focusgroup = React.lazy(() => import("@pages/focus-groups/index"));
const Focusgroupdetails = React.lazy(() =>
    import("@pages/focus-group/focusGroup/index")
);
const FocusGroupLive = React.lazy(() =>
    import("@pages/focus-group/focusGroup/live/index")
);

// Complaints
const MyComplaints = React.lazy(() => import("@pages/complaints/index"));
const NewComplaint = React.lazy(() => import("@pages/complaints/NewComplaint"));
const ComplaintDetails = React.lazy(() =>
    import("@pages/admin/complaints/ComplaintDetails")
);

// Other
const Jitci = React.lazy(() => import("@pages/jitci/index"));

const { NotFound } = lazily(() => import("@components/Errors/NotFound"));
const { TaleDashbaordMainCard } = lazily(() =>
    import("@components/TaleDashbaordMainCard")
);

export const shared_routes = (role) =>
    filterRoutes(
        [
            // Home
            {
                index: true,
                element: <Home />,
            },

            // Account
            {
                path: "/account",
                element: <AccountArea />,
                caseSensitive: true,
            },
            {
                path: "/account/change-password",
                element: <ChangePassword />,
            },

            {
                path: "/account/change-password-connected",
                element: <ChangePasswordConnected />,
            },

            // Assistance & Policy
            {
                path: "/assistance",
                element: <Assistance />,
                caseSensitive: true,
            },
            {
                path: "/assistance/registration-account-management",
                element: <AssistanceRegisterAccountmanagement />,
            },
            {
                path: "/policy",
                element: <Policy />,
                caseSensitive: true,
            },

            // Surveys
            {
                path: "/surveys",
                element: <Surveys />,
                caseSensitive: true,
            },
            {
                path: "/survey/:surveyId",
                element: <Survey />,
                caseSensitive: true,
            },
            {
                path: "/survey/:surveyId/language",
                element: <SurveyLanguage />,
            },
            {
                path: "/survey/:surveyId/questions",
                element: <SurveyQuestions />,
                caseSensitive: true,
            },
            {
                path: "/survey/:surveyId/completed",
                element: <SurveyCompletionPage />,
                caseSensitive: true,
            },

            // Focus Groups
            {
                path: "/focus-groups",
                element: <Focusgroup />,
                caseSensitive: true,
            },
            {
                path: "/focus-group/:focusGroupID",
                element: <Focusgroupdetails />,
                caseSensitive: true,
            },
            {
                path: "/focus-group/:focusGroupID/live",
                element: <FocusGroupLive />,
                caseSensitive: true,
            },

            // Complaints
            {
                path: "/complaints",
                element: <MyComplaints basePath="/complaints" />,
            },
            {
                path: "/complaints/new",
                element: <NewComplaint basePath="/complaints" />,
            },
            {
                path: "/complaints/:id",
                element: <ComplaintDetails basePath="/complaints" isAdmin={false} />,
            },

            // Other
            {
                path: "/jitci",
                element: <Jitci />,
                caseSensitive: true,
            },

            // Catch-all (ALWAYS LAST)
            {
                path: "/*",
                element: (
                    <TaleDashbaordMainCard className="flex items-center justify-center">
                        <NotFound />
                    </TaleDashbaordMainCard>
                ),
            },
        ],
        role
    );
